
















































































































































































import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import ParentProductViewModel from "@/chipply/view-model/ParentProductViewModel";
import CartViewModel from "@/chipply/view-model/CartViewModel";
import { Utils } from "chipply-common";
import PackageViewModel from "@/chipply/view-model/PackageViewModel";
import QuantityComponent from "./QuantityComponent.vue";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";

@Component({
    components: {
        QuantityComponent,
    },
})
export default class PackageDetailDesktopRow extends Vue {
    @Prop({
        type: Object,
    })
    item!: ParentProductViewModel;

    @Prop({
        type: Object,
    })
    productVm!: ProductViewModel;

    @Prop({
        type: Object,
    })
    cartVm!: CartViewModel;

    @Prop({
        type: Object,
    })
    packageVm!: PackageViewModel;

    @Prop({
        type: Boolean,
        default: false,
    })
    isHeaderRow!: boolean;

    public Utils = Utils;

    public customizeButtonClicked(productId: number) {
        this.$emit("customizeButtonClicked", productId);
    }

    public deleteButtonClicked(groupProductPkgFinalizedId: number) {
        this.$emit("deleteButtonClicked", groupProductPkgFinalizedId);
    }

    public quantityChanged(productVm: ProductViewModel, parentProductVm: ParentProductViewModel, amount: number) {
        this.$emit("quantityChanged", productVm, parentProductVm, amount);
    }

    public get isItemFinalized() {
        if (this.isHeaderRow) {
            if (this.productVm.productGroupDetails) {
                return this.item.pkgFinalizedGroupProductMembers.length > 0;
            } else {
                return this.productVm.pkgItemFinalized;
            }
        }
        return false;
    }

    public get groupProductStartingPrice() {
        if (this.item && this.item.parent && this.item.parent.product) {
            return this.item.parent.product.storeProductGroupStartingPrice;
        }
        return 0;
    }

    public get shouldShowQuantityComponent() {
        if (this.cartVm.isRequestor) return false;
        if (this.productVm.pkgItemFinalized && !this.productVm.productGroupDetails) return true;
        if (!this.isHeaderRow) return true;

        return false;
    }

    public get computedRowImage() {
        if (this.productVm.productGroupDetails && this.isHeaderRow) {
            return this.productVm.productGroupDetails.storeProductGroupPreviewImageUrl;
        }
        return this.productVm.selectedImage.previewImageSrc;
    }
}
